import React from "react";
import PropTypes from "prop-types";
import ActionsMenu from "./actions-menu";
import Icon from "../elements/icon";
import classNames from "classnames";

const ThreeDotActionsMenu = ({
  options,
  menuClassName,
  triggerClassName,
  title,
  disabled,
  iconSize = 1,
  contentWidth,
  ...rest
}) => {
  return (
    <ActionsMenu
      options={options}
      menuClassName={menuClassName}
      triggerClassName={triggerClassName}
      disabled={disabled}
      title={title}
      trigger={({ isOpen }) => (
        <Icon
          title="prospect actions"
          className={classNames("et--three-dot-actions-menu--trigger", { "is-active": isOpen })}
          size={iconSize}
          icon="more-horiz"
        />
      )}
      {...rest}
    />
  );
};

ThreeDotActionsMenu.propTypes = {
  disabled: PropTypes.bool,
  iconSize: PropTypes.number,
  menuClassName: PropTypes.string,
  options: PropTypes.array,
  title: PropTypes.string,
  triggerClassName: PropTypes.string,
  contentWidth: PropTypes.number,
};

export default ThreeDotActionsMenu;
